export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_22.e2f3b726.jpg";